import { render } from "./ExtraAnswerComponent.vue?vue&type=template&id=2fb66cf2&scoped=true"
import script from "./ExtraAnswerComponent.vue?vue&type=script&lang=js"
export * from "./ExtraAnswerComponent.vue?vue&type=script&lang=js"

import "./ExtraAnswerComponent.vue?vue&type=style&index=0&id=2fb66cf2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fb66cf2"]])

export default __exports__